// @ts-nocheck
const UserSkeleton = () => {

    return (
        <div>Es lädt...</div>
    )
}

export default UserSkeleton